import { useCallback } from "react";
import { Dialog } from "../../../components/Dialog";

import { useStyles } from "../styles";

import { CampaignAwarded } from "../../../types/campaignAwarded";

import Stack from "@mui/material/Stack";

type VideoAwardedProps = {
  data: CampaignAwarded;
  open: boolean;
  onClose: () => void;
};

export function VideoAwarded({ onClose, open, data }: VideoAwardedProps) {
  const styles = useStyles();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      title={data?.name}
      open={open}
      onClose={handleClose}
    >
      <Stack spacing={2}>
        <video className={styles.video} src={data?.video} controls autoPlay />
      </Stack>
    </Dialog>
  );
}
